// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1I0Jz","image":"Header_image__2ye8O","name":"Header_name__3T5gq","info":"Header_info__2lJ9k","infoRow":"Header_infoRow__1wp4i"};